import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { Panel } from "@cinch-nx/landing-ui-shared";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import { SVG } from "@cinch-nx/shared-ui";
import cx from "classnames";
import Mail from "../../assets/mail.svg";
import Phone from "../../assets/phone.svg";
import Smartphone from "../../assets/smartphone.svg";
import WhatsApp from "../../assets/whats-app.svg";
import { handleTrackingClick } from "../../helpers/helpers";
import styles from "./contact-card.module.css";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var SvgComponent = {
    mail: Mail,
    phone: Phone,
    smartphone: Smartphone,
    whatsapp: WhatsApp
};
var ContactCard = function(param) {
    var svgType = param.svgType, heading = param.heading, body = param.body, cta = param.cta, category = param.category, href = param.href, _shouldHideOnDesktop = param.shouldHideOnDesktop, shouldHideOnDesktop = _shouldHideOnDesktop === void 0 ? false : _shouldHideOnDesktop;
    var trackEvent = useAnalytics().trackEvent;
    return /*#__PURE__*/ _jsxs(Panel, {
        className: cx(styles.panel, shouldHideOnDesktop && styles.hiddenDesktop),
        classNames: {
            body: styles.panelFlex
        },
        isPadded: true,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.iconWrapper,
                children: /*#__PURE__*/ _jsx(SVG, {
                    children: SvgComponent[svgType.toLocaleLowerCase()],
                    width: 32,
                    height: 32
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.textContainer,
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        className: styles.panelHeading,
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.textWrapper,
                        children: /*#__PURE__*/ _jsx(Text, {
                            fontSize: "xs",
                            fontWeight: "book",
                            children: body
                        })
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: "".concat(href ? href : cta),
                        "aria-label": cta,
                        className: styles.link,
                        onClick: function() {
                            return handleTrackingClick(trackEvent, {
                                eventName: "Support - click contact card",
                                label: cta,
                                category: category
                            });
                        },
                        children: cta
                    })
                ]
            })
        ]
    });
};
export default ContactCard;
